<template>
  <div class="errorPage container">
    <template v-if="error.isProduct">
      <product-not-available
        :categories="error.categories"
        :products="error.products"
        :breadcrumbs="error.breadcrumbs"
        title="Przepraszamy, ten produkt nie jest już w naszej ofercie. "
      />
    </template>
    <template v-else-if="error.statusCode === 404">
      <ErrorContent />
    </template>
    <template v-else>
      <div class="errorPage__content">
        <div class="errorPage__text">
          <span class="errorPage__textColor" v-if="error.statusCode">{{ error.statusCode }}</span>
          <h1 v-if="error.message">
            {{ error.message }}
          </h1>
          <h1 v-else>Wystąpił błąd</h1>
        </div>
        <border-link text="Wróć na stronę główną" to="/" />
      </div>
    </template>
  </div>
</template>

<script>
import BorderLink from '~/components/BorderLink';
import ProductNotAvailable from '~/containers/Product/ProductNotAvailable';
import CategoriesSlider from '@/components/CategoriesSlider';
import ErrorContent from '@/components/ErrorContent';

export default {
  components: {
    ErrorContent,
    CategoriesSlider,
    BorderLink,
    ProductNotAvailable,
  },
  layout: 'default',
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.$auth.setAxiosHeader(this.$cookies.get('auth'));
  },
  mounted() {
    if (this.$nuxt.$loading._isVue) {
      if (this.$nuxt.$loading.finishCreate()) {
        this.$nuxt.$loading.finishCreate();
      }
    }
  },
};
</script>

<style lang="scss">
.errorPage {
  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    padding: 10rem;
    margin-top: 14rem;

    @include rwd('tablet') {
      margin-top: 16rem;
    }
    background-color: $cWhite;
    min-height: 30rem;
    text-align: center;

    @include rwd('tablet') {
      padding: 6rem 4rem;
    }

    @include rwd('small-tablet') {
      margin-top: 0;
    }
  }

  &__text {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: 600;
    font-size: 4rem;
    line-height: 4.5rem;
    margin-bottom: 5rem;

    @include rwd('tablet') {
      font-size: 3rem;
      line-height: 3.5rem;
    }
  }

  &__textColor {
    font-size: 8rem;
    line-height: 8.5rem;
    color: $cSec;
    font-weight: 600;
    margin-bottom: 3rem;

    @include rwd('tablet') {
      font-size: 6rem;
      line-height: 6.5rem;
    }
  }
}
</style>
